import React, { useState, useRef, useEffect } from "react";
import { FaCircleInfo } from "react-icons/fa6";
import "../assets/css/InfoTooltip.css";
import { useTranslate } from "../services/translation";

interface InfoTooltipProps {
  descriptionKey: string;
}

const InfoTooltip: React.FC<InfoTooltipProps> = ({ descriptionKey }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const { translate } = useTranslate();

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setShowTooltip(false);
      }
    };

    if (showTooltip) {
      document.addEventListener("click", handleClickOutside);
    }

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [showTooltip]);

  return (
    <div className="info-tooltip-container" ref={containerRef}>
      <div
        className="info-icon"
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        onClick={() => setShowTooltip(!showTooltip)}
      >
        <FaCircleInfo />
      </div>
      {showTooltip && (
        <div className="tooltip-content">
          {translate(descriptionKey as any)}
        </div>
      )}
    </div>
  );
};

export default InfoTooltip;
